svg{display:block}p{text-align:center;margin:20px 0 60px;font-size:1.25em}p.success{color:#73af55}p.error{color:#d06079}
/*# sourceMappingURL=bool-visualizer.component-65G7YJFO.css.map */
